import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const inventoryTransactionsService = createApi({
  reducerPath: "inventoryTransactionsService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["inventoryTransactions"],
  endpoints: (builder) => ({
    // ✅ Get All with Pagination
    getAllInventoryTransactions: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryTransactionsController.getAllInventoryTransactionsWithPagination}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Search
    searchInventoryTransactions: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryTransactionsController.searchInventoryTransactions}`,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Save
    saveInventoryTransactions: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryTransactionsController.saveInventoryTransactions}`,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Update
    updateInventoryTransactions: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryTransactionsController.updateInventoryTransactions}/${body.id}`,
        method: "PUT",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Delete
    deleteInventoryTransactions: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryTransactionsController.deleteInventoryTransactions}/${body.id}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Get by ID
    getInventoryTransactionsById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryTransactionsController.getInventoryTransactionsById}/${body.id}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Get All without pagination
    findAllInventoryTransactions: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryTransactionsController.getAllInventoryTransactions}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Bulk Upload (XLSX only)
    bulkUploadInventoryTransactions: builder.mutation({
      query: (body) => {
        return {
          url: `${userManagement.inventoryTransactionsController.bulkUploadInventoryTransactions}`,
          method: "POST",
          body: body.payload,
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
  }),
});

export const {
  useGetAllInventoryTransactionsMutation,
  useSearchInventoryTransactionsMutation,
  useSaveInventoryTransactionsMutation,
  useUpdateInventoryTransactionsMutation,
  useDeleteInventoryTransactionsMutation,
  useGetInventoryTransactionsByIdMutation,
  useFindAllInventoryTransactionsMutation,
  useBulkUploadInventoryTransactionsMutation,
} = inventoryTransactionsService;
